import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper } from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

const SpecializedPrograms = () => {
  useEffect(() => {
    const initSpecializedProgramsSwiper = () => {
      const swiperElement = document.querySelector('.specialized-programs-swiper');
      
      if (swiperElement && !swiperElement.swiper) {
        try {
          new Swiper(swiperElement, {
            modules: [Pagination, Autoplay],
            loop: true,
            speed: 1500,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
            },
            slidesPerView: 'auto',
            spaceBetween: 20,
            pagination: {
              el: '.specialized-programs-swiper .swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 1,
                spaceBetween: 40
              },
              1200: {
                slidesPerView: 2,
                spaceBetween: 20
              }
            }
          });
        } catch (error) {
          console.error('Error initializing Specialized Programs Swiper:', error);
        }
      }
    };

    const swiperTimer = setTimeout(() => {
      initSpecializedProgramsSwiper();
    }, 500);

    return () => {
      clearTimeout(swiperTimer);
    };
  }, []);

  return (
      <section id="why-us" className="why-us section light-background">
      <div className="container">
            
        <div className="row gy-4">
          <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
            <div className="specialized-programs-info bg-danger text-white p-4 rounded">
              <h3>Specialized Programs</h3>
              <p >
                Mewar University's Specialized Programs combine academic excellence with industry-focused training. 
                They prepare students with practical skills and knowledge to excel in their chosen careers.
              </p>
            </div>
          </div>
          
          <div className="col-lg-8 d-flex align-items-stretch">
            <div className="swiper specialized-programs-swiper w-100">
              <div className="swiper-wrapper mb-4">
                <div className="swiper-slide">
                  <div className="speciprogram-item mx-2" data-aos="fade-up" data-aos-delay="200">
                    <div className="icon-box d-flex flex-column justify-content-center align-items-center">
                      <div className="d-flex justify-content-between mb-1 position-relative">
                        <div className="text-start">
                          <span className="text-start textprimary fs-16 fw-bold d-inline-block">B.Tech</span>
                          <h6 className="text-start program_title fs-14 mb-0">
                            <Link to="/btech-electrical-engineering" className="stretched-link text-decoration-none">
                              Electrical Engineering (Lateral Entry)
                            </Link>
                          </h6>
                        </div>
                        <div className="program-img rounded-3 overflow-hidden">
                          <i className="bi bi-bank"></i>
                        </div>
                      </div>
                      <h6 className="fs-14 mb-3">
                        <b>Duration: </b> - <span className="text-secondary">3 Years (In Flexible Shift Timings)</span>
                      </h6>
                      <div className="program_footer border-top gap-3 pt-2 mb-3 d-flex justify-content-between flex-wrap align-items-center">
                        <div className="">
                          <span className="fs-13 text-secondary">Approved by</span>
                          <h6 className="fs-13 m-0">UGC, AICTE</h6>
                        </div>
                        <div>
                          <span className="fs-13 text-secondary">Eligibility: (Min 1 year experience)</span>
                          <h6 className="fs-13 m-0">Polytechnic Diploma / B.Sc / B.Voc</h6>
                        </div>
                      </div>
                      <button 
                        className="more-btn w-100 fs-16 text-uppercase" 
                        onClick={() => {
                          // Dispatch custom event to trigger global modal
                          window.dispatchEvent(new CustomEvent('showApplicationModal'));
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="speciprogram-item mx-2" data-aos="fade-up" data-aos-delay="200">
                    <div className="icon-box d-flex flex-column justify-content-center align-items-center">
                      <div className="d-flex justify-content-between mb-1 position-relative">
                        <div className="text-start">
                          <span className="text-start textprimary fs-16 fw-bold d-inline-block">B.Tech</span>
                          <h6 className="text-start program_title fs-14 mb-0">
                            <Link to="/btech-mechanical-engineering" className="stretched-link text-decoration-none">
                              Mechanical Engineering (Lateral Entry)
                            </Link>
                          </h6>
                        </div>
                        <div className="program-img rounded-3 overflow-hidden">
                          <i className="bi bi-bank"></i>
                        </div>
                      </div>
                      <h6 className="fs-14 mb-3">
                        <b>Duration: </b> - <span className="text-secondary">3 Years (In Flexible Shift Timings)</span>
                      </h6>
                      <div className="program_footer border-top gap-3 pt-2 mb-3 d-flex justify-content-between flex-wrap align-items-center">
                        <div className="">
                          <span className="fs-13 text-secondary">Approved by</span>
                          <h6 className="fs-13 m-0">UGC, AICTE</h6>
                        </div>
                        <div>
                          <span className="fs-13 text-secondary">Eligibility: (Min 1 year experience)</span>
                          <h6 className="fs-13 m-0">Polytechnic Diploma / B.Sc / B.Voc</h6>
                        </div>
                      </div>
                      <button 
                        className="more-btn w-100 fs-16 text-uppercase" 
                        onClick={() => {
                          // Dispatch custom event to trigger global modal
                          window.dispatchEvent(new CustomEvent('showApplicationModal'));
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="speciprogram-item mx-2" data-aos="fade-up" data-aos-delay="200">
                    <div className="icon-box d-flex flex-column justify-content-center align-items-center">
                      <div className="d-flex justify-content-between mb-1 position-relative">
                        <div className="text-start">
                          <span className="text-start textprimary fs-16 fw-bold d-inline-block">B.Tech</span>
                          <h6 className="text-start program_title fs-14 mb-0">
                            <Link to="/btech-electronic-and-communication-engneering" className="stretched-link text-decoration-none">
                              Electronic and Communication (Lateral Entry)
                            </Link>
                          </h6>
                        </div>
                        <div className="program-img rounded-3 overflow-hidden">
                          <i className="bi bi-bank"></i>
                        </div>
                      </div>
                      <h6 className="fs-14 mb-3">
                        <b>Duration: </b> - <span className="text-secondary">3 Years (In Flexible Shift Timings)</span>
                      </h6>
                      <div className="program_footer border-top gap-3 pt-2 mb-3 d-flex justify-content-between flex-wrap align-items-center">
                        <div className="">
                          <span className="fs-13 text-secondary">Approved by</span>
                          <h6 className="fs-13 m-0">UGC, AICTE</h6>
                        </div>
                        <div>
                          <span className="fs-13 text-secondary">Eligibility: (Min 1 year experience)</span>
                          <h6 className="fs-13 m-0">Polytechnic Diploma / B.Sc / B.Voc</h6>
                        </div>
                      </div>
                      <button 
                        className="more-btn w-100 fs-16 text-uppercase" 
                        onClick={() => {
                          // Dispatch custom event to trigger global modal
                          window.dispatchEvent(new CustomEvent('showApplicationModal'));
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="speciprogram-item mx-2" data-aos="fade-up" data-aos-delay="200">
                    <div className="icon-box d-flex flex-column justify-content-center align-items-center">
                      <div className="d-flex justify-content-between mb-1 position-relative">
                        <div className="text-start">
                          <span className="text-start textprimary fs-16 fw-bold d-inline-block">B.Tech</span>
                          <h6 className="text-start program_title fs-14 mb-0">
                            <Link to="/btech-computer-science-engineering" className="stretched-link text-decoration-none">
                              Computer Science Engineering (Lateral Entry)
                            </Link>
                          </h6>
                        </div>
                        <div className="program-img rounded-3 overflow-hidden">
                          <i className="bi bi-bank"></i>
                        </div>
                      </div>
                      <h6 className="fs-14 mb-3">
                        <b>Duration: </b> - <span className="text-secondary">3 Years (In Flexible Shift Timings)</span>
                      </h6>
                      <div className="program_footer border-top gap-3 pt-2 mb-3 d-flex justify-content-between flex-wrap align-items-center">
                        <div className="">
                          <span className="fs-13 text-secondary">Approved by</span>
                          <h6 className="fs-13 m-0">UGC, AICTE</h6>
                        </div>
                        <div>
                          <span className="fs-13 text-secondary">Eligibility: (Min 1 year experience)</span>
                          <h6 className="fs-13 m-0">Polytechnic Diploma / B.Sc / B.Voc</h6>
                        </div>
                      </div>
                      <button 
                        className="more-btn w-100 fs-16 text-uppercase" 
                        onClick={() => {
                          // Dispatch custom event to trigger global modal
                          window.dispatchEvent(new CustomEvent('showApplicationModal'));
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="speciprogram-item mx-2" data-aos="fade-up" data-aos-delay="200">
                    <div className="icon-box d-flex flex-column justify-content-center align-items-center">
                      <div className="d-flex justify-content-between mb-1 position-relative">
                        <div className="text-start">
                          <span className="text-start textprimary fs-16 fw-bold d-inline-block">B.Tech</span>
                          <h6 className="text-start program_title fs-14 mb-0">
                            <Link to="/btech-civil-engineering" className="stretched-link text-decoration-none">
                              Civil Engineering (Lateral Entry)
                            </Link>
                          </h6>
                        </div>
                        <div className="program-img rounded-3 overflow-hidden">
                          <i className="bi bi-bank"></i>
                        </div>
                      </div>
                      <h6 className="fs-14 mb-3">
                        <b>Duration: </b> - <span className="text-secondary">3 Years (In Flexible Shift Timings)</span>
                      </h6>
                      <div className="program_footer border-top gap-3 pt-2 mb-3 d-flex justify-content-between flex-wrap align-items-center">
                        <div className="">
                          <span className="fs-13 text-secondary">Approved by</span>
                          <h6 className="fs-13 m-0">UGC, AICTE</h6>
                        </div>
                        <div>
                          <span className="fs-13 text-secondary">Eligibility: (Min 1 year experience)</span>
                          <h6 className="fs-13 m-0">Polytechnic Diploma / B.Sc / B.Voc</h6>
                        </div>
                      </div>
                      <button 
                        className="more-btn w-100 fs-16 text-uppercase" 
                        onClick={() => {
                          // Dispatch custom event to trigger global modal
                          window.dispatchEvent(new CustomEvent('showApplicationModal'));
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecializedPrograms;
